(function hbSelleasyPopupQtyFixSafe() {
  // ===== Singleton guard (sehr wichtig) =====
  if (window.__hbSelleasyFixLoaded) return;
  window.__hbSelleasyFixLoaded = true;

  // ===== State =====
  let lastTeethCount = 1; // Zähne gesamt = (Zähne pro Löffel) * (Löffel-Menge)
  let lastInStock = true;

  // ===== Utils =====
  const norm = (s) => (s || "").toLowerCase().replace(/\s+/g, " ").trim();
  const isVisible = (el) => !!(el && el.getClientRects && el.getClientRects().length);

  // Deep walk NUR innerhalb eines Roots (Popup), nicht global
  function deepWalk(root, cb) {
    if (!root) return;
    cb(root);

    // light dom
    if (root.querySelectorAll) {
      root.querySelectorAll("*").forEach(cb);
    }

    // shadow dom (open)
    const nodes = root.querySelectorAll ? root.querySelectorAll("*") : [];
    for (const el of nodes) {
      if (el.shadowRoot) deepWalk(el.shadowRoot, cb);
    }
  }

  function findPopupRootFast() {
    // Selleasy Popup ist sichtbar, wenn der Titel existiert (wie bei dir)
    const titleEl = Array.from(document.querySelectorAll("body *")).find((el) => {
      if (!isVisible(el)) return false;
      const t = norm(el.textContent);
      return t.includes("entdecken sie passende artikel");
    });

    if (!titleEl) return null;

    // zum Container hochlaufen
    let c = titleEl;
    for (let i = 0; i < 12; i++) {
      if (!c) break;
      if (isVisible(c) && c.clientWidth > 260 && c.clientHeight > 220) return c;
      c = c.parentElement || c.host || null;
    }
    return titleEl;
  }

  function readTeethFromPage() {
    const els = Array.from(document.querySelectorAll("[data-hb-teeth-count]"));
    for (const el of els) {
      if (el.hasAttribute("data-hb-teeth-disabled")) continue;
      const v = parseInt(el.value, 10);
      if (Number.isFinite(v) && v > 0) return v;
    }
    return lastTeethCount || 1;
  }

  // ✅ FIX: Menge auch dann finden, wenn Quantity-Input NICHT im <form> steckt,
  // sondern nur per form="product-form-..." verknüpft ist (Focal Standard)
  function readMainQtyFromTrigger(triggerEl) {
    // triggerEl kann Button oder Form sein
    const form =
      triggerEl && triggerEl.tagName && triggerEl.tagName.toLowerCase() === "form"
        ? triggerEl
        : triggerEl && triggerEl.closest
        ? triggerEl.closest("form")
        : null;

    let qtyEl = null;

    // 1) Versuch: direkt im Form
    if (form) {
      qtyEl =
        form.querySelector('input[name="quantity"]:not([disabled])') ||
        form.querySelector('input[name="quantity"]');
    }

    // 2) Fallback: Input hängt evtl. außerhalb, aber mit form="<form.id>"
    if (!qtyEl && form && form.id) {
      qtyEl = document.querySelector(`input[name="quantity"][form="${CSS.escape(form.id)}"]`);
    }

    // 3) Letzter Fallback: allgemein sichtbaren quantity nehmen (wenn eindeutig)
    if (!qtyEl) {
      const candidates = Array.from(document.querySelectorAll('input[name="quantity"]')).filter(isVisible);
      if (candidates.length === 1) qtyEl = candidates[0];
    }

    const q = qtyEl ? parseInt(qtyEl.value, 10) : 1;
    return Number.isFinite(q) && q > 0 ? q : 1;
  }

  function readInStockFromClickSource(triggerEl) {
    // Primär: Lieferzeit-Property aus deinem Add-to-cart Form (sehr zuverlässig)
    const form = triggerEl && triggerEl.closest ? triggerEl.closest("form") : null;
    if (form) {
      const lz = form.querySelector("input[name='properties[Lieferzeit]']");
      if (lz && lz.value) {
        const v = norm(lz.value);
        if (v.includes("woche") || v.includes("wochen") || v.includes("4–6") || v.includes("4-6")) return false;
      }
    }

    // Fallback (leicht): sichtbare Lager-Keywords (kein body.textContent Vollscan)
    const badge = document.querySelector(".inventoryNote, .label--subdued, .label2, .label1");
    if (badge) {
      const t = norm(badge.textContent);
      if (t.includes("bestellbar") || t.includes("4–6") || t.includes("4-6")) return false;
      if (t.includes("sofort verfügbar") || t.includes("auf lager")) return true;
    }

    return true; // im Zweifel Express nicht entfernen
  }

  // Capture state beim Klick / Submit
  document.addEventListener(
    "click",
    (e) => {
      const btn =
        e.target &&
        e.target.closest &&
        e.target.closest("[data-product-add-to-cart-button], button[type='submit']");
      if (!btn) return;

      // ✅ Zähne pro Löffel * Löffel-Menge
      const teethPerBucket = readTeethFromPage();
      const mainQty = readMainQtyFromTrigger(btn);
      lastTeethCount = teethPerBucket * mainQty;

      lastInStock = readInStockFromClickSource(btn);
    },
    true
  );

  document.addEventListener(
    "submit",
    (e) => {
      const form = e.target;
      if (!form || !form.querySelector) return;
      if (!form.querySelector("input[name='id']")) return;

      // ✅ Zähne pro Löffel * Löffel-Menge
      const teethPerBucket = readTeethFromPage();
      const mainQty = readMainQtyFromTrigger(form);
      lastTeethCount = teethPerBucket * mainQty;

      lastInStock = readInStockFromClickSource(form);
    },
    true
  );

  // ===== Popup helpers =====
  function setInputValue(input, qty) {
    if (!input) return;
    input.value = String(qty);
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function findCard(popupRoot, predicateText) {
    let hit = null;
    deepWalk(popupRoot, (n) => {
      if (hit) return;
      if (!n || n.nodeType !== 1) return;
      if (!isVisible(n)) return;
      if (n.tagName && n.tagName.toLowerCase() === "lb-upsell-flat-card") {
        const t = norm(n.textContent);
        if (predicateText(t)) hit = n;
      }
    });
    return hit;
  }

  function findCheckbox(card) {
    let cb = null;
    deepWalk(card.shadowRoot || card, (n) => {
      if (cb) return;
      if (n && n.nodeType === 1 && n.matches && n.matches("input[type='checkbox'], input[type='radio']")) cb = n;
    });
    return cb;
  }

  function findQtyInput(card) {
    let input = null;
    deepWalk(card.shadowRoot || card, (n) => {
      if (input) return;
      if (!n || n.nodeType !== 1 || !n.matches) return;
      if (n.matches("input.lb-qty-count")) input = n;
      else if (n.matches("input[type='number'][name*='qty' i]")) input = n;
      else if (n.matches("input[type='number'][aria-label*='Quantity' i]")) input = n;
    });
    return input;
  }

  // ===== Stock lesen (aus product-form.liquid JSON data-hb-tooth-stock) =====
  function readToothStock() {
    const el = document.querySelector("[data-hb-tooth-stock]");
    if (!el) return { hasData: false, inStock: true, maxQty: null, variantId: null };

    try {
      const d = JSON.parse(el.textContent || "{}");
      const variantId = d.variant_id != null ? String(d.variant_id) : null;
      const managed = d.managed === "shopify";
      const qty = Number(d.qty);

      if (!variantId) return { hasData: false, inStock: true, maxQty: null, variantId: null };

      // Wenn Shopify-Tracking aktiv: harte Logik nach Menge
      if (managed) {
        const maxQty = Number.isFinite(qty) ? Math.max(0, Math.floor(qty)) : 0;
        return { hasData: true, inStock: maxQty > 0, maxQty, variantId };
      }

      // Nicht getrackt: nicht sicher begrenzbar -> anzeigen
      return { hasData: true, inStock: true, maxQty: null, variantId };
    } catch (e) {
      return { hasData: false, inStock: true, maxQty: null, variantId: null };
    }
  }

  function clampQty(qty, max) {
    const q = parseInt(qty, 10);
    const m = parseInt(max, 10);
    if (!Number.isFinite(q) || q <= 0) return 1;
    if (Number.isFinite(m) && m > 0) return Math.min(q, m);
    return q;
  }

  function setToothQty(input, desired, maxQty) {
    const qty = Number.isFinite(maxQty) && maxQty > 0 ? clampQty(desired, maxQty) : desired;
    setInputValue(input, qty);
  }

  function applyMaxAndClamp(input, maxQty) {
    if (!input || !Number.isFinite(maxQty) || maxQty <= 0) return;

    input.setAttribute("max", String(maxQty));

    const v = parseInt(input.value, 10);
    const fixed = clampQty(v, maxQty);
    if (String(fixed) !== String(v)) setInputValue(input, fixed);

    if (!input.getAttribute("data-hb-clamp-hooked")) {
      input.setAttribute("data-hb-clamp-hooked", "1");
      const handler = () => {
        const v2 = parseInt(input.value, 10);
        const fixed2 = clampQty(v2, maxQty);
        if (String(fixed2) !== String(v2)) setInputValue(input, fixed2);
      };
      input.addEventListener("input", handler);
      input.addEventListener("change", handler);
    }
  }

  // ===== Plus-Button im Stepper wirklich sperren (falls Buttons eindeutig gefunden werden) =====
  function findQtyStepperButtons(card) {
    let plus = null;
    let minus = null;

    deepWalk(card.shadowRoot || card, (n) => {
      if (!n || n.nodeType !== 1 || !n.matches) return;

      if (n.matches("button")) {
        const t = norm(n.textContent);
        const al = norm(n.getAttribute("aria-label"));
        const ti = norm(n.getAttribute("title"));

        const isPlus =
          t === "+" ||
          al.includes("increase") ||
          al.includes("erhöhen") ||
          al.includes("increase quantity") ||
          ti.includes("increase") ||
          ti.includes("erhöhen");

        const isMinus =
          t === "-" ||
          al.includes("decrease") ||
          al.includes("verringern") ||
          al.includes("decrease quantity") ||
          ti.includes("decrease") ||
          ti.includes("verringern");

        if (isPlus && !plus) plus = n;
        if (isMinus && !minus) minus = n;
      }
    });

    return { plus, minus };
  }

  function syncStepperDisabled(input, plusBtn, minusBtn, maxQty) {
    if (!input) return;
    const v = parseInt(input.value, 10) || 1;

    if (minusBtn) minusBtn.disabled = v <= 1;

    if (plusBtn && Number.isFinite(maxQty) && maxQty > 0) {
      plusBtn.disabled = v >= maxQty;
    }
  }

  function hookStepperLimit(card, input, maxQty) {
    if (!card || !input || !Number.isFinite(maxQty) || maxQty <= 0) return;
    if (card.getAttribute("data-hb-stepper-hooked")) return;
    card.setAttribute("data-hb-stepper-hooked", "1");

    const { plus, minus } = findQtyStepperButtons(card);
    const resync = () => syncStepperDisabled(input, plus, minus, maxQty);

    resync();

    input.addEventListener("input", () => setTimeout(resync, 0));
    input.addEventListener("change", () => setTimeout(resync, 0));

    if (plus) plus.addEventListener("click", () => setTimeout(resync, 0), true);
    if (minus) minus.addEventListener("click", () => setTimeout(resync, 0), true);
  }

  // ===== HARTER REQUEST-CLAMP (damit 100 NIE in den Warenkorb kommt) =====
  function isCartEndpoint(url) {
    const u = String(url || "");
    return u.includes("/cart/add") || u.includes("/cart/update") || u.includes("/cart/change");
  }

  function clampJsonBody(obj, toothVariantId, maxQty) {
    if (!obj || !toothVariantId || !Number.isFinite(maxQty)) return obj;

    if (obj.id != null && String(obj.id) === String(toothVariantId) && obj.quantity != null) {
      const q = parseInt(obj.quantity, 10);
      if (Number.isFinite(q) && q > maxQty) obj.quantity = maxQty;
      if (Number.isFinite(q) && q < 1) obj.quantity = 1;
      return obj;
    }

    if (Array.isArray(obj.items)) {
      obj.items = obj.items.map((it) => {
        if (!it) return it;
        if (it.id != null && String(it.id) === String(toothVariantId) && it.quantity != null) {
          const q = parseInt(it.quantity, 10);
          if (Number.isFinite(q) && q > maxQty) it.quantity = maxQty;
          if (Number.isFinite(q) && q < 1) it.quantity = 1;
        }
        return it;
      });
      return obj;
    }

    if (obj.updates && typeof obj.updates === "object") {
      const key = String(toothVariantId);
      if (obj.updates[key] != null) {
        const q = parseInt(obj.updates[key], 10);
        if (Number.isFinite(q) && q > maxQty) obj.updates[key] = maxQty;
        if (Number.isFinite(q) && q < 1) obj.updates[key] = 1;
      }
      return obj;
    }

    return obj;
  }

  function clampUrlEncodedBody(bodyStr, toothVariantId, maxQty) {
    if (!bodyStr || !toothVariantId || !Number.isFinite(maxQty)) return bodyStr;

    try {
      const usp = new URLSearchParams(bodyStr);

      const id = usp.get("id");
      if (id && String(id) === String(toothVariantId)) {
        const q = parseInt(usp.get("quantity") || "1", 10);
        if (Number.isFinite(q) && q > maxQty) usp.set("quantity", String(maxQty));
        if (Number.isFinite(q) && q < 1) usp.set("quantity", "1");
        return usp.toString();
      }

      const key = `updates[${toothVariantId}]`;
      if (usp.has(key)) {
        const q = parseInt(usp.get(key) || "1", 10);
        if (Number.isFinite(q) && q > maxQty) usp.set(key, String(maxQty));
        if (Number.isFinite(q) && q < 1) usp.set(key, "1");
        return usp.toString();
      }

      for (let i = 0; i < 50; i++) {
        const kId = `items[${i}][id]`;
        const kQty = `items[${i}][quantity]`;
        if (!usp.has(kId)) continue;
        if (String(usp.get(kId)) === String(toothVariantId)) {
          const q = parseInt(usp.get(kQty) || "1", 10);
          if (Number.isFinite(q) && q > maxQty) usp.set(kQty, String(maxQty));
          if (Number.isFinite(q) && q < 1) usp.set(kQty, "1");
        }
      }

      return usp.toString();
    } catch (e) {
      return bodyStr;
    }
  }

  function clampFormData(fd, toothVariantId, maxQty) {
    if (!fd || !toothVariantId || !Number.isFinite(maxQty)) return fd;

    const id = fd.get("id");
    if (id && String(id) === String(toothVariantId)) {
      const q = parseInt(fd.get("quantity") || "1", 10);
      if (Number.isFinite(q) && q > maxQty) fd.set("quantity", String(maxQty));
      if (Number.isFinite(q) && q < 1) fd.set("quantity", "1");
    }

    const key = `updates[${toothVariantId}]`;
    if (fd.get(key) != null) {
      const q = parseInt(fd.get(key) || "1", 10);
      if (Number.isFinite(q) && q > maxQty) fd.set(key, String(maxQty));
      if (Number.isFinite(q) && q < 1) fd.set(key, "1");
    }

    for (let i = 0; i < 50; i++) {
      const kId = `items[${i}][id]`;
      const kQty = `items[${i}][quantity]`;
      const vid = fd.get(kId);
      if (!vid) continue;

      if (String(vid) === String(toothVariantId)) {
        const q = parseInt(fd.get(kQty) || "1", 10);
        if (Number.isFinite(q) && q > maxQty) fd.set(kQty, String(maxQty));
        if (Number.isFinite(q) && q < 1) fd.set(kQty, "1");
      }
    }

    return fd;
  }

  function clampRequestIfNeeded(url, body) {
    if (!isCartEndpoint(url)) return body;

    const stock = readToothStock();
    if (!stock || !stock.variantId || !Number.isFinite(stock.maxQty) || stock.maxQty <= 0) {
      return body;
    }

    const toothVariantId = stock.variantId;
    const maxQty = stock.maxQty;

    if (typeof body === "string") {
      const trimmed = body.trim();

      if (trimmed.startsWith("{") || trimmed.startsWith("[")) {
        try {
          const obj = JSON.parse(body);
          const clamped = clampJsonBody(obj, toothVariantId, maxQty);
          return JSON.stringify(clamped);
        } catch (e) {}
      }

      return clampUrlEncodedBody(body, toothVariantId, maxQty);
    }

    if (typeof FormData !== "undefined" && body instanceof FormData) {
      return clampFormData(body, toothVariantId, maxQty);
    }

    if (body && typeof body === "object") {
      return clampJsonBody(body, toothVariantId, maxQty);
    }

    return body;
  }

  // ---- fetch patch
  const _fetch = window.fetch;
  window.fetch = function patchedFetch(input, init) {
    try {
      const url = typeof input === "string" ? input : (input && input.url) || "";
      if (!isCartEndpoint(url)) return _fetch.apply(this, arguments);

      if (!init || !("body" in init) || init.body == null) return _fetch.apply(this, arguments);

      const newBody = clampRequestIfNeeded(url, init.body);
      if (newBody === init.body) return _fetch.apply(this, arguments);

      const nextInit = Object.assign({}, init, { body: newBody });
      return _fetch.call(this, input, nextInit);
    } catch (e) {
      return _fetch.apply(this, arguments);
    }
  };

  // ---- XHR patch
  const _open = XMLHttpRequest.prototype.open;
  const _send = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function patchedOpen(method, url) {
    this.__hb_url = url;
    return _open.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function patchedSend(body) {
    try {
      const url = this.__hb_url || "";
      if (!isCartEndpoint(url)) return _send.apply(this, arguments);

      if (body == null) return _send.apply(this, arguments);

      const newBody = clampRequestIfNeeded(url, body);
      return _send.call(this, newBody);
    } catch (e) {
      return _send.apply(this, arguments);
    }
  };

  // ===== Hauptlogik =====
  function applyToPopupOnce() {
    const popup = findPopupRootFast();
    if (!popup) return;

    if (!lastInStock) {
      const express = findCard(popup, (t) => t.includes("expressversand") || t.includes("übernacht"));
      if (express) {
        const cb = findCheckbox(express);
        if (cb && cb.checked) cb.click();
        express.style.display = "none";
      }
    }

    const tooth = findCard(popup, (t) =>
      t.includes("ersatzzahn") ||
      (t.includes("zahn") && (t.includes("kl2") || t.includes("kl3") || t.includes("kl4")))
    );
    if (!tooth) return;

    const stock = readToothStock();

    if (stock.hasData && stock.inStock === false) {
      const cbOff = findCheckbox(tooth);
      if (cbOff && cbOff.checked) cbOff.click();
      tooth.style.display = "none";
      return;
    } else {
      tooth.style.display = "";
    }

    const cbTooth = findCheckbox(tooth);
    const qtyInput = findQtyInput(tooth);
    const maxQty = Number.isFinite(stock.maxQty) && stock.maxQty > 0 ? stock.maxQty : null;

    if (Number.isFinite(maxQty)) {
      lastTeethCount = clampQty(lastTeethCount, maxQty);
    }

    if (qtyInput) {
      if (Number.isFinite(maxQty)) {
        applyMaxAndClamp(qtyInput, maxQty);
        hookStepperLimit(tooth, qtyInput, maxQty);
      }

      setToothQty(qtyInput, lastTeethCount, maxQty);

      setTimeout(() => {
        if (Number.isFinite(maxQty)) {
          applyMaxAndClamp(qtyInput, maxQty);
          hookStepperLimit(tooth, qtyInput, maxQty);
        }
        setToothQty(qtyInput, lastTeethCount, maxQty);
      }, 120);

      setTimeout(() => {
        if (Number.isFinite(maxQty)) {
          applyMaxAndClamp(qtyInput, maxQty);
          hookStepperLimit(tooth, qtyInput, maxQty);
        }
        setToothQty(qtyInput, lastTeethCount, maxQty);
      }, 320);
    }

    if (cbTooth && !cbTooth.getAttribute("data-hb-tooth-hooked")) {
      cbTooth.setAttribute("data-hb-tooth-hooked", "1");

      cbTooth.addEventListener("change", () => {
        const popup2 = findPopupRootFast();
        if (!popup2) return;

        const tooth2 = findCard(popup2, (t) =>
          t.includes("ersatzzahn") ||
          (t.includes("zahn") && (t.includes("kl2") || t.includes("kl3") || t.includes("kl4")))
        );
        if (!tooth2) return;

        const qty2 = findQtyInput(tooth2);
        if (!qty2) return;

        const stock2 = readToothStock();
        const max2 = Number.isFinite(stock2.maxQty) && stock2.maxQty > 0 ? stock2.maxQty : null;

        if (Number.isFinite(max2)) {
          applyMaxAndClamp(qty2, max2);
          hookStepperLimit(tooth2, qty2, max2);
        }

        setToothQty(qty2, lastTeethCount, max2);
        setTimeout(() => setToothQty(qty2, lastTeethCount, max2), 120);
      });
    }
  }

  // ===== Debounced observer (keine Endlosschleife) =====
  let scheduled = false;
  let timer = null;

  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;

    timer = setTimeout(() => {
      scheduled = false;
      applyToPopupOnce();

      setTimeout(applyToPopupOnce, 120);
      setTimeout(applyToPopupOnce, 320);
    }, 80);
  }

  const mo = new MutationObserver(() => scheduleApply());
  mo.observe(document.documentElement, { childList: true, subtree: true });

  setTimeout(scheduleApply, 800);
})();

/* === HB: Sticky ATC -> trigger main PDP ATC (Selleasy Popup) === */
(function hbStickyAtcProxy() {
  if (window.__hbStickyAtcProxyLoaded) return;
  window.__hbStickyAtcProxyLoaded = true;

  function findMainPdpAtcButton() {
    const btns = document.querySelectorAll('[data-product-add-to-cart-button], button[name="add"]');

    for (const btn of btns) {
      if (!btn) continue;

      if (btn.id === "StickyAddToCart") continue;
      if (btn.closest("product-sticky-form")) continue;

      if (btn.closest("cart-drawer, #CartDrawer, [data-cart-drawer]")) continue;

      return btn;
    }
    return null;
  }

  document.addEventListener(
    "click",
    (e) => {
      const stickyBtn = e.target && e.target.closest && e.target.closest("#StickyAddToCart,[data-hb-sticky-atc]");
      if (!stickyBtn) return;

      const mainBtn = findMainPdpAtcButton();

      if (mainBtn) {
        mainBtn.click();
        return;
      }

      console.warn("[HB Sticky ATC] Main PDP add-to-cart button not found");
    },
    true
  );
})();
